import { ConfirmDialog } from '@roc/ui';
import { observer } from 'mobx-react';
import { useLoanActionsStore } from '../hooks/useLoanActionsStore';

export const ApproveEntityInformationModal = observer(
  ({ open, handleClose }) => {
    const { loanActionsStore } = useLoanActionsStore();

    const confirm = () => {
      loanActionsStore.approveEntityInformation();
      handleClose();
    };

    return (
      <ConfirmDialog
        open={open}
        confirmButtonText={'Yes'}
        handleClose={handleClose}
        handleCancel={handleClose}
        handleConfirm={confirm}
        title={'Approve Entity Information'}
        body={`Are you sure you want to approve the Entity Review section docs?`}
      />
    );
  }
);
